<template>
    <custom-search
        :label="label"
        :display-value="itemCurrent.name"
        :disabled="!enabled"
        placeholder="Buscar marca .."
        :fetch-items="searchBrands"
        @select="onSelect"
        @focus="$emit('focus')"
        @blur="$emit('blur')"
    />
</template>

<script>
import { mapActions } from "vuex";

import CustomSearch from "@/components/utils/CustomSearch.vue";

export default {
    name: "BrandSearch",
    components: {
        CustomSearch
    },
    model: {
        prop: "itemCurrent",
        event: "input"
    },
    props: {
        defaultFilters: {
            default: () => ({
                active: true
            }),
            type: Object,
            required: false
        },
        itemCurrent: {
            default: () => ({ name: "" }),
            type: Object,
            required: false
        },
        label: {
            default: () => "",
            type: String,
            required: false
        },
        enabled: {
            default: () => true,
            type: Boolean,
            required: false
        }
    },
    emits: ["blur", "focus", "input"],
    methods: {
        ...mapActions("brands", ["listAllBrands"]),
        searchBrands(keyword, required = false) {
            return this.listAllBrands({
                ...this.defaultFilters,
                keyword,
                required
            });
        },
        onSelect(item) {
            this.$emit("input", item);
        }
    }
};
</script>
